import React from "react";
import LegalPage from "../components/shared/LegalPage";
import SEOHead from "../components/shared/SEOHead";
import { BreadcrumbStructuredData } from "../components/shared/StructuredData";
import { useSharedContent } from "../providers/ContentProvider";

const AccessibilityPage: React.FC = () => {
  const { content, loading } = useSharedContent();
  const legal = content.legal;
  const contact = content.contact;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="text-2xl mb-2">⏳</div>
          <div>טוען...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <SEOHead
        title="הצהרת נגישות | Touch Event"
        description="הצהרת הנגישות של Touch Event - מחויבות להנגשת האתר לאנשים עם מוגבלויות. שירותי עיסוי רפואי לאירועים ומשרדים."
        path="/accessibility"
      />
      <BreadcrumbStructuredData items={[
        { name: 'דף הבית', url: 'https://touchevent.site/' },
        { name: 'הצהרת נגישות', url: 'https://touchevent.site/accessibility' },
      ]} />
      <LegalPage title={legal?.accessibilityTitle || "הצהרת נגישות"} lastUpdated={legal?.lastUpdated}>
        <div className="text-[#4b3a2c] leading-relaxed whitespace-pre-line">
          {legal?.accessibilityText || ""}
        </div>
        <p className="text-[#4b3a2c] mt-6">
          נתקלתם בבעיה? צרו קשר: {contact.email} | {contact.phone}
        </p>
      </LegalPage>
    </>
  );
};

export default AccessibilityPage;
